import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import getEligibilities from '../../../actions/admin-eligibilities';
import MultiSelect from '../../common/form/multi-select';

class EligibilityDropdowns extends Component {
  constructor(props) {
    super(props);

    this.state = {
      groupValues: [],
      abmCodeValues: [],
      wseBandValues: [],
      postcodeValues: [],
      subZoneValues: [],
      zoneValues: []
    };
  }
  componentWillMount() {
    this.props.dispatch(getEligibilities());
  }

  createAbmCodeList = abmCodes =>
    abmCodes.map(curr => ({
      label: curr,
      value: curr
    }));

  createWseBandList = wseBands =>
    wseBands.map(curr => ({
      label: curr,
      value: curr
    }));

  createPostcodeList = postcodes =>
    postcodes.map(curr => ({
      label: curr,
      value: curr
    }));

  createGroupList = groups =>
    groups.map(curr => ({
      label: `${curr.name}`,
      value: curr.id
    }));

  createSubZoneList = subZones =>
    subZones.map(curr => ({
      label: `${curr.name}`,
      value: curr.id
    }));

  createZoneList = zones =>
    zones.map(curr => ({
      label: `${curr.name}`,
      value: curr.id
    }));

  handleGroupChange = (e) => {
    this.setState({ groupValues: e });
  };

  handleAbmCodeChange = (e) => {
    this.setState({ abmCodeValues: e });
  };

  handleWseBandChange = (e) => {
    this.setState({ wseBandValues: e });
  };

  handlePostcodeChange = (e) => {
    this.setState({ postcodeValues: e });
  };

  handleSubZoneChange = (e) => {
    this.setState({ subZoneValues: e });
  };

  handleZoneChange = (e) => {
    this.setState({ zoneValues: e });
  };

  render() {
    const { eligibilities, model } = this.props;
    const {
      abmCodeValues,
      wseBandValues,
      groupValues,
      postcodeValues,
      subZoneValues,
      zoneValues
    } = this.state;

    return (
      <div>
        <Row>
          <Col md={4}>
            {eligibilities.abm_codes && (
              <MultiSelect
                data={this.createAbmCodeList(eligibilities.abm_codes) || []}
                value={this.props.abm_codes || abmCodeValues}
                model={`deep.${model}.abm_codes`}
                controlId='abm_code'
                label='Eligible Abm Regions'
                placeholder='Select...'
                onChange={this.handleAbmCodeChange}
              />
            )}
          </Col>
          <Col md={4}>
            {eligibilities.wse_bands && (
              <MultiSelect
                data={this.createWseBandList(eligibilities.wse_bands) || []}
                value={this.props.wse_bands || wseBandValues}
                model={`deep.${model}.wse_bands`}
                controlId='wse_band'
                label='Eligible WSE bands'
                placeholder='Select...'
                onChange={this.handleWseBandChange}
              />
            )}
          </Col>
          <Col md={4}>
            {eligibilities.groups && (
              <MultiSelect
                data={this.createGroupList(eligibilities.groups) || []}
                value={this.props.groups || groupValues}
                model={`deep.${model}.groups`}
                controlId='group'
                label='Eligible Groups'
                placeholder='Select...'
                onChange={this.handleGroupChange}
                withAllOption
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            {eligibilities.postcodes && (
              <MultiSelect
                data={this.createPostcodeList(eligibilities.postcodes) || []}
                value={this.props.postcodes || postcodeValues}
                model={`deep.${model}.postcodes`}
                controlId='postcode'
                label='Eligible Postcodes'
                placeholder='Select...'
                onChange={this.handlePostcodeChange}
              />
            )}
          </Col>
          <Col md={4}>
            {eligibilities.sub_zones && (
              <MultiSelect
                data={this.createSubZoneList(eligibilities.sub_zones) || []}
                value={this.props.sub_zones || subZoneValues}
                model={`deep.${model}.sub_zones`}
                controlId='sub_zone'
                label='Eligible Sub Zones'
                placeholder='Select...'
                onChange={this.handleSubZoneChange}
              />
            )}
          </Col>
          <Col md={4}>
            {eligibilities.zones && (
              <MultiSelect
                data={this.createZoneList(eligibilities.zones) || []}
                value={this.props.zones || zoneValues}
                model={`deep.${model}.zones`}
                controlId='zone'
                label='Eligible Zones'
                placeholder='Select...'
                onChange={this.handleZoneChange}
              />
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  eligibilities: state.eligibilities
});

export default connect(mapStateToProps)(EligibilityDropdowns);



// WEBPACK FOOTER //
// ./src/components/admin/objectives/eligibility-dropdowns.jsx